import React, { Dispatch, ReactChildren, ReactElement, ReactNode, useState } from 'react'
import Collapsed from '@components/accordian/Collapsed'
import Expanded from '@components/accordian/Expanded'
import { AnimatePresence } from 'framer-motion'

interface IAccordianProps {
  children: ReactNode
  initialTab?: number | null
  controlled?: {
    tab: number
    setTab: Dispatch<any>
  }
}

export interface IItemProps {
  /**
   * Unique label of Tab to show when clicked.
   */
  children: any
  isOpen: boolean
}

interface EnrichedChildren {
  children?: ReactNode
}

const Item = (props: IItemProps) => {
  const { children } = props

  return (
    <>{children}</>
  )
}
const Accordion = (props: IAccordianProps) => {
  const { children, initialTab = null, controlled } = props
  const initialState = controlled
    ? controlled.tab
    : initialTab ? initialTab : null
  const [selectedTab, setSelectedTab] = useState<number | null>(initialState)
  const handleOpen = (e: any) => {
    const id = parseInt(e.currentTarget.getAttribute('data-id'), 10)
    if (isNaN(id)) {
      return
    }

    if (controlled) {
      if (id !== controlled.tab) {
        controlled.setTab(id)
      }
    } else {
      if (id !== selectedTab) {
        setSelectedTab(id)
      }
    }
  }

  return (
    <AnimatePresence>
      {React.Children.map(children, child => {
        if (!React.isValidElement<EnrichedChildren>(child)) {
          return child
        }

        if (!child.props.children) {
          return child
        }
        const id = child.props.children[0].props.id

        const collapsed = React.cloneElement(child.props.children[0], {
          // handleOpen,
        })

        const expandedProps = controlled
          ? { id, selectedTab: controlled.tab }
          : { id, selectedTab }
        const expanded = React.cloneElement(child.props.children[1], expandedProps)

        // const expanded = child.props.children[1]
        const isSelected = controlled
          ? controlled.tab === id
          : selectedTab === id

        return (
          <div
            data-id={id}
            className={`acItem ${isSelected ? 'active' : ''}`}
            onClick={handleOpen}>
            {collapsed}
            {expanded}
          </div>
        )

      })}
    </AnimatePresence>
  )
}
Accordion.Collapsed = Collapsed
Accordion.Expanded = Expanded
Accordion.Item = Item
export default Accordion
